<template>
  <div>
    <v-layout justify-end class="pb-4">
      <Search />
    </v-layout>
      <div v-if="singleUser">
        <UserInfo :singleUser="singleUser" />
      </div>
      <v-card v-if="!singleUser">
        <div class="users_loader">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </v-card>
    <DirectoriesList v-if="singleUser && !isAdmin" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Search from '../Users/Search.vue';
import UserInfo from './UserInfo.vue';
import DirectoriesList from './Directories/DirectoriesList.vue';

export default {
  name: 'user-single',
  components: {
    UserInfo,
    Search,
    DirectoriesList,
  },
  computed: {
    ...mapGetters('users', [
      'singleUser',
    ]),
    isAdmin() {
      return this.singleUser.role === 'admin' || this.singleUser.role === 'super-admin';
    },
  },
};
</script>
